import { z } from 'zod';
import { JsonValueSchema } from './common';

export const CLARIFY_QUESTION_TYPES = [
  'single_select',
  'multi_select',
  'number',
  'text',
  'boolean',
] as const;

export const CLARIFY_BIND_TARGETS = ['context', 'prompt_var'] as const;

export const ClarifyQuestionTypeEnum = z.enum(CLARIFY_QUESTION_TYPES);

export const ClarifyBindTargetEnum = z.enum(CLARIFY_BIND_TARGETS);

export const ClarifyQuestionBindingSchema = z.object({
  target: ClarifyBindTargetEnum,
  field: z.string().min(1),
});

export const ClarifyQuestionSchema = z.object({
  id: z.string().min(1),
  question: z.string().min(1),
  type: ClarifyQuestionTypeEnum,
  options: z.array(z.string().min(1)).min(1).optional(),
  default: JsonValueSchema.optional(),
  required: z.boolean().optional(),
  bindsTo: ClarifyQuestionBindingSchema,
});

export const ClarifyResponseSchema = z.object({
  questions: z.array(ClarifyQuestionSchema).max(4),
  rationale: z.string().min(1).optional(),
});

export type ClarifyQuestionType = (typeof CLARIFY_QUESTION_TYPES)[number];
export type ClarifyBindTarget = (typeof CLARIFY_BIND_TARGETS)[number];
export type ClarifyQuestionBinding = z.infer<
  typeof ClarifyQuestionBindingSchema
>;
export type ClarifyQuestion = z.infer<typeof ClarifyQuestionSchema>;
export type ClarifyResponse = z.infer<typeof ClarifyResponseSchema>;
